import React, { useState } from 'react';
import './VirtualMallChangePassword.scss';
import { toast } from 'react-toastify';
import { virtualMallChangePasswordApi } from './VirtualMallApi/api';

export default function VirtualMallChangePassword() {
    const [passwordData, setPasswordData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    });

    const handleInputChange = (field) => (e) => {
        setPasswordData(prev => ({
            ...prev,
            [field]: e.target.value
        }));
    };

    const handlePasswordChange = async (e) => {
        e.preventDefault();
        if (passwordData.newPassword !== passwordData.confirmPassword) {
            toast.error('New passwords do not match!');
            return;
        }
        try {
            const referal_id = localStorage.getItem("virtual_referal_id");
            const payload = {
                referal_id: referal_id,
                password: passwordData.newPassword
            };

            const response = await virtualMallChangePasswordApi(payload);

            if (response.result === true) {
                toast.success("Password changed successfully!");
                setPasswordData({
                    newPassword: '',
                    confirmPassword: ''
                });
            } else {
                toast.error(response.message || "Failed to change password");
            }
        } catch (error) {
            console.error("Error changing password:", error);
            const errorMsg = error.response?.data?.message || "Failed to change password";
            toast.error(errorMsg);
        }
    };

    return (
        <div className="dashboard-section">
            <h2>Change Password</h2>
            <div className="password-section">
                <form className="password-form" onSubmit={handlePasswordChange}>
                    <div className="form-group">
                        <label>New Password</label>
                        <input
                            type="password"
                            value={passwordData.newPassword}
                            onChange={handleInputChange('newPassword')}
                            className="form-input"
                            placeholder="Enter new password"
                            required
                            minLength="6"
                        />
                        <div className="input-hint">Password must be at least 6 characters long</div>
                    </div>
                    <div className="form-group">
                        <label>Confirm New Password</label>
                        <input
                            type="password"
                            value={passwordData.confirmPassword}
                            onChange={handleInputChange('confirmPassword')}
                            className="form-input"
                            placeholder="Confirm new password"
                            required
                            minLength="6"
                        />
                    </div>
                    <div className="form-actions">
                        <button type="submit" className="primary-btn">
                            Change Password
                        </button>
                        <button
                            type="button"
                            className="secondary-btn"
                            onClick={() => setPasswordData({
                                currentPassword: '',
                                newPassword: '',
                                confirmPassword: ''
                            })}
                        >
                            Clear
                        </button>
                    </div>
                </form>

                <div className="password-requirements">
                    <h4>Password Requirements:</h4>
                    <ul>
                        <li>At least 6 characters long</li>
                        <li>Include uppercase and lowercase letters</li>
                        <li>Include at least one number</li>
                        <li>Include special characters for better security</li>
                    </ul>
                </div>
            </div>
        </div>
    );
}
